export default __webpack_public_path__ + "static/media/EG_Mix-1.415ba563.wav";